import { render, staticRenderFns } from "./DepartmentListField.vue?vue&type=template&id=6d933171&"
import script from "./DepartmentListField.vue?vue&type=script&lang=js&"
export * from "./DepartmentListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports